export default "__VITE_PUBLIC_ASSET__0a957cfc__"